import { Injectable } from '@angular/core';
import { Locale } from '../locale/locale-models';
import { SharedDotcomConstants } from '../../dotcom-constants';
import { DotcomFlags } from '../../dotcom-locale-flags';
import { I18nInfo, UsanaMarketService } from '@usana/ux/markets';
import { Observable, ReplaySubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LocaleService {
    private locale = '';
    private localeSubject = new ReplaySubject<string>(1);

    private readonly dotcomFlags: Record<string, Locale> = DotcomFlags;

    constructor(private usanaMarketService: UsanaMarketService) {
        this.usanaMarketService.geti18NInfoSubject().subscribe((i18nInfo: I18nInfo) => {
            const marketId = i18nInfo.current.currentMarketId;
            if (marketId && marketId !== this.locale) {
                this.locale = marketId;
                this.localeSubject.next(this.locale);
            }
        });
    }

    getLocale(): string {
        return this.locale;
    }

    getEmptyLocaleObject(): Locale {
        return {
            key: undefined,
            hasOlapic: false,
            hasIncelligence: true,
            hasHybridTechnology: true,
            hasOlivol: true,
            hasScienceDisclaimer: false,
            hasChampions: true,
            hasDrLee: true,
            hasEnergy: true,
            hasWeightManagement: true,
            hasBlog: true,
            hasAtsSearch: false,
            hasRetailShopping: false,
        };
    }

    getLocaleObject(): Locale {
        return this.getLocaleObjectOf(this.getLocale());
    }

    getLocaleObjectOf(key: string): Locale {
        const loc = this.dotcomFlags[key];
        if (loc) {
            return loc;
        }
        return this.getEmptyLocaleObject();
    }

    getLocaleObservable(): Observable<string> {
        return this.localeSubject.asObservable();
    }

    allowNewDotcomLanding(locale: string): boolean {
        return SharedDotcomConstants.DOTCOM_LANDING_LOCALES.includes(locale);
    }
}
